module.exports = __webpack_public_path__ + "img/bg-audio-3.ce70fd16.png";